package com.appcreator.client.firebase.functions

import dev.gitlive.firebase.functions.externals.getFunctions
import dev.gitlive.firebase.functions.externals.httpsCallable
import dev.gitlive.firebase.functions.externals.invoke
import kotlinx.coroutines.await


actual suspend fun load(
    function: String,
    region: String,
    queryParameters: Map<String, String>
): Any {

    val functions = getFunctions(regionOrCustomDomain = region)
    val raw = httpsCallable(functions, function, null)
        .invoke(queryParameters)
        .await()
        .data

  return raw!!
}